import { render, staticRenderFns } from "./IconSvgSettings.vue?vue&type=template&id=142c43ce&scoped=true&"
import script from "./IconSvgSettings.vue?vue&type=script&lang=js&"
export * from "./IconSvgSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c43ce",
  null
  
)

export default component.exports